import { render, staticRenderFns } from "./GenericOrganism.vue?vue&type=template&id=1d9b90fb&"
import script from "./GenericOrganism.vue?vue&type=script&lang=js&"
export * from "./GenericOrganism.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports